module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }